// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/register/partner_registrations/firstparty/v1/partner_registration.proto

/* oxlint-disable */

/** Status of a partner registration */
export const ApiStatus = {
  /** STATUS_UNSPECIFIED - Unspecified status */
  STATUS_UNSPECIFIED: "STATUS_UNSPECIFIED",
  /**
   * Registration is pending
   */
  pending: "pending",
  /**
   * Registration is completed
   */
  completed: "completed",
  /**
   * Contract has been signed
   */
  contract_signed: "contract_signed",
  /**
   * User has started the registration process
   */
  user_started: "user_started",
} as const;

export type ApiStatus = typeof ApiStatus[keyof typeof ApiStatus];

export namespace ApiStatus {
  export type STATUS_UNSPECIFIED = typeof ApiStatus.STATUS_UNSPECIFIED;
  export type pending = typeof ApiStatus.pending;
  export type completed = typeof ApiStatus.completed;
  export type contract_signed = typeof ApiStatus.contract_signed;
  export type user_started = typeof ApiStatus.user_started;
}

export function apiStatusFromJSON(object: any): ApiStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return ApiStatus.STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiStatus.pending;
    case 2:
    case "completed":
      return ApiStatus.completed;
    case 3:
    case "contract_signed":
      return ApiStatus.contract_signed;
    case 4:
    case "user_started":
      return ApiStatus.user_started;
    default:
      return ApiStatus.STATUS_UNSPECIFIED;
  }
}

export function apiStatusToJSON(object: ApiStatus): string {
  switch (object) {
    case ApiStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case ApiStatus.pending:
      return "pending";
    case ApiStatus.completed:
      return "completed";
    case ApiStatus.contract_signed:
      return "contract_signed";
    case ApiStatus.user_started:
      return "user_started";
    default:
      return "STATUS_UNSPECIFIED";
  }
}

/** Flow type for registration eligibility */
export const ApiFlowType = {
  /** FLOW_TYPE_UNSPECIFIED - Unspecified flow type */
  FLOW_TYPE_UNSPECIFIED: "FLOW_TYPE_UNSPECIFIED",
  /**
   * Data is missing and the user is redirected to the standard register flow
   */
  manual: "manual",
  /**
   * User signs up through partner-register.qonto.com with pre-filled data
   */
  seamless: "seamless",
} as const;

export type ApiFlowType = typeof ApiFlowType[keyof typeof ApiFlowType];

export namespace ApiFlowType {
  export type FLOW_TYPE_UNSPECIFIED = typeof ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  export type manual = typeof ApiFlowType.manual;
  export type seamless = typeof ApiFlowType.seamless;
}

export function apiFlowTypeFromJSON(object: any): ApiFlowType {
  switch (object) {
    case 0:
    case "FLOW_TYPE_UNSPECIFIED":
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
    case 1:
    case "manual":
      return ApiFlowType.manual;
    case 2:
    case "seamless":
      return ApiFlowType.seamless;
    default:
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  }
}

export function apiFlowTypeToJSON(object: ApiFlowType): string {
  switch (object) {
    case ApiFlowType.FLOW_TYPE_UNSPECIFIED:
      return "FLOW_TYPE_UNSPECIFIED";
    case ApiFlowType.manual:
      return "manual";
    case ApiFlowType.seamless:
      return "seamless";
    default:
      return "FLOW_TYPE_UNSPECIFIED";
  }
}

/** PartnerRegistration represents a partner registration resource */
export interface ApiPartnerRegistration {
  /** Unique identifier of the partner registration */
  readonly id: string;
  /** Name of the partner */
  readonly partnerName: string;
  /** Type of partner (e.g. "legal_tech") */
  readonly partnerType: string;
  /** Flow this registration is eligible for */
  readonly flowType: ApiFlowType;
  /** URL where the user will be redirected after registration completion (embed apps only) */
  readonly partnerRedirectUrl?:
    | string
    | null
    | undefined;
  /** ID of the organization linked to this partner registration */
  readonly organizationId: string;
  /** Current status of the partner registration */
  readonly status: ApiStatus;
  /** OAuth parameters for partner authentication (only present when configured) */
  readonly partnerOauthParams?: ApiPartnerOauthParams | null | undefined;
}

/** OAuth parameters for partner authentication */
export interface ApiPartnerOauthParams {
  /** OAuth client identifier */
  readonly clientId: string;
  /** OAuth state parameter */
  readonly state: string;
  /** OAuth redirect URI */
  readonly redirectUri: string;
  /** OAuth scopes requested */
  readonly scopes: string;
}

export const ApiPartnerRegistration: MessageFns<ApiPartnerRegistration> = {
  fromJSON(object: any): ApiPartnerRegistration {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      partnerName: isSet(object.partner_name) ? globalThis.String(object.partner_name) : "",
      partnerType: isSet(object.partner_type) ? globalThis.String(object.partner_type) : "",
      flowType: isSet(object.flow_type) ? apiFlowTypeFromJSON(object.flow_type) : ApiFlowType.FLOW_TYPE_UNSPECIFIED,
      partnerRedirectUrl: isSet(object.partner_redirect_url) ? globalThis.String(object.partner_redirect_url) : null,
      organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "",
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
      partnerOauthParams: isSet(object.partner_oauth_params)
        ? ApiPartnerOauthParams.fromJSON(object.partner_oauth_params)
        : null,
    };
  },

  toJSON(message: ApiPartnerRegistration): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.partnerName !== undefined && message.partnerName !== null) {
      obj.partner_name = message.partnerName;
    }
    if (message.partnerType !== undefined && message.partnerType !== null) {
      obj.partner_type = message.partnerType;
    }
    if (message.flowType !== undefined && message.flowType !== null) {
      obj.flow_type = apiFlowTypeToJSON(message.flowType);
    }
    if (message.partnerRedirectUrl !== undefined && message.partnerRedirectUrl !== null) {
      obj.partner_redirect_url = message.partnerRedirectUrl;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.partnerOauthParams !== undefined && message.partnerOauthParams !== null) {
      obj.partner_oauth_params = ApiPartnerOauthParams.toJSON(message.partnerOauthParams);
    }
    return obj;
  },
};

export const ApiPartnerOauthParams: MessageFns<ApiPartnerOauthParams> = {
  fromJSON(object: any): ApiPartnerOauthParams {
    return {
      clientId: isSet(object.client_id) ? globalThis.String(object.client_id) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      redirectUri: isSet(object.redirect_uri) ? globalThis.String(object.redirect_uri) : "",
      scopes: isSet(object.scopes) ? globalThis.String(object.scopes) : "",
    };
  },

  toJSON(message: ApiPartnerOauthParams): unknown {
    const obj: any = {};
    if (message.clientId !== undefined && message.clientId !== null) {
      obj.client_id = message.clientId;
    }
    if (message.state !== undefined && message.state !== null) {
      obj.state = message.state;
    }
    if (message.redirectUri !== undefined && message.redirectUri !== null) {
      obj.redirect_uri = message.redirectUri;
    }
    if (message.scopes !== undefined && message.scopes !== null) {
      obj.scopes = message.scopes;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
